/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const UpdateBillingPriceOutputJsonApiModel = {
  id: "",
  "billing-price": {
    jsonApi: "hasOne",
    type: "billing-prices",
  },
};
